(function () {
	const initCollapsibleContent = () => {
		$(".collapsible-content__toggle").unbind("click").on("click", function () {
			const parent = $(this).parent();
			const closeOtherAccordions = parent.closest(".collapsible-content__items").hasClass("hide-other-accordion");

			if (!parent.hasClass("active")) {
				if(closeOtherAccordions){
					parent
						.siblings(".collapsible-content__item.active")
						.removeClass("active")
						.find(".collapsible-content__answer")
						.stop()
						.slideUp(300);
				}
				parent.addClass("active");
				$(this).next().stop().slideDown(300);
			} else {
				parent.removeClass("active");
				$(this).next().stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
